export default {
    en: {
        titleSend: "Send Message",
        titleMy: "My Messages"
    },
    zh: {
        titleSend: "发送消息",
        titleMy: "我的消息"
    }
}